module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01_m_jp.38ec49b265290c3926cdf1593f176ad7.png";